import {Observable} from 'rxjs';
import {RestQueryParams} from '../base/queryParams';
import {marineHubAPI} from '../provider/marineHubAPI';

export function resetPasswordAPI(authToken: string, plainPassword: string): Observable<any> {
    return marineHubAPI.post(
        `api/users/set_new_password`,
        {
            password: plainPassword,
        },
        new RestQueryParams(),
        {
            'X-Authentication-Token': authToken
        }
    );
}
